import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: _ctx.deal !== null,
    title: _ctx.helper.trans('labels.assign_trader'),
    "footer-class": " d-flex justify-content-between",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.deal = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TraderMultiselect, {
            multiple: false,
            small: false,
            modelValue: _ctx.trader,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trader) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}